<ngx-loading [show]="loading"></ngx-loading>
<table mat-table [dataSource]="dataSource" class="mat-elevation-z8 w-full bg-accent-900">
  <ng-container *ngFor="let columnName of displayedColumns" [matColumnDef]="columnName">
    <th
      mat-header-cell
      *matHeaderCellDef
      [class]="columnsOptions[columnName]?.thClass || 'padding-header-class'"
    >
      <span
        class="data-table-cell-content"
        [matTooltip]="
          columnsOptions[columnName]?.title
            ? (columnsOptions[columnName]?.title | transloco)
            : (columnName.replace('_', ' ') | titlecase | transloco)
        "
        matTooltipPosition="above"
      >
        {{
          (columnsOptions[columnName]?.title | transloco) ||
            (columnName.replace('_', ' ') | titlecase | transloco)
        }}
      </span>
    </th>

    <td
      mat-cell
      *matCellDef="let element"
      [class]="columnsOptions[columnName]?.tdClass || 'padding-class'"
    >
      <ng-container [ngSwitch]="columnsOptions[columnName]?.type">
        <span
          *ngSwitchCase="'dateTime'"
          class="data-table-cell-content"
          [matTooltip]="
            getCellText(element, columnName) === '-'
              ? '-'
              : (element[columnName] | dateTransform: 'YYYY-MM-DDTHH:mm:ss.SSSSSSZ' : false : true)
          "
          matTooltipPosition="above"
        >
          <ng-container *ngIf="getCellText(element, columnName) === '-'; else dateTimeCellText">
            -
          </ng-container>
          <ng-template #dateTimeCellText>
            {{ element[columnName] | dateTransform: 'YYYY-MM-DDTHH:mm:ss.SSSSSSZ' : false : true }}
          </ng-template>
        </span>
        <span
          *ngSwitchCase="'percentage'"
          class="data-table-cell-content"
          [matTooltip]="getCellText(element, columnName)"
          matTooltipPosition="above"
        >
          {{ getCellText(element, columnName) === '-' ? '-' : getCellText(element, columnName) }}
        </span>
        <span
          *ngSwitchDefault
          class="data-table-cell-content"
          [matTooltip]="getCellText(element, columnName)"
          matTooltipPosition="above"
        >
          <ng-container *ngIf="isArchivedStatusCell(element, columnName); else nonArchivedCellText">
            <span [class]="getArchivedStatusClass(element, columnName)">
              {{ getCellText(element, columnName) | transloco }}
            </span>
          </ng-container>
          <ng-template #nonArchivedCellText>
            <ng-container
              *ngIf="isSummaryIdentifierCell(element, columnName); else defaultCellText"
            >
              <span class="summary-row-chip">{{ getSummaryRowLabel(element) | transloco }}</span>
              <span class="data-table-cell-text">
                {{ getCellText(element, columnName) }}
              </span>
            </ng-container>
          </ng-template>
          <ng-template #defaultCellText>
            {{ getCellText(element, columnName) === '-' ? '-' : getCellText(element, columnName) }}
          </ng-template>
        </span>
      </ng-container>
    </td>
  </ng-container>

  <tr mat-header-row *matHeaderRowDef="displayedColumns" class="bg-accent-800"></tr>
  <tr mat-row *matRowDef="let row; columns: displayedColumns" [ngClass]="getRowClass(row)"></tr>
</table>
